module.exports = __webpack_public_path__ + "awsfalconhelp.png";